import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { COLORS } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';

import { Input } from 'modules/form/index';

const Label = styled(Text)`
  pointer-events: none;
  position: absolute;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
  z-index: 24;
  background: ${COLORS.WHITE};
  padding: 0 4px;
  top: -2px;
  left: 12px;
  font-size: 12px;
  text-transform: capitalize;
`;

const Root = styled.div`
  position: relative;
`;

const CustomeInputTime = styled(Input)`
  border-radius: 8px;
  width: 100%;
  border: 1px solid ${COLORS.GHOST};
`;

export default function CueTimeInput({
  label,
  onClick,
  required,
  value,
  min,
  onChange,
  width,
  step,
}) {
  const rootRef = useRef(null);

  // The shared TextInput (@cuemath/comps) doesn't forward a `step` prop to its
  // underlying <input>, so the native time picker stays at 1-minute granularity.
  // Set the step attribute directly on the DOM node so the picker honours it
  // (step is in seconds; 300 = 5 minutes).
  useEffect(() => {
    if (step == null || !rootRef.current) {
      return;
    }
    const input = rootRef.current.querySelector('input[type="time"]');
    if (input) {
      input.setAttribute('step', String(step));
    }
  }, [step]);

  return (
    <Root ref={rootRef} className="cue-time-input">
      <Label variant="body3" color={COLORS.SCORPION}>
        {label}
      </Label>
      <CustomeInputTime
        type="time"
        width={width}
        required={required}
        value={value}
        min={min}
        onChange={onChange}
      />
    </Root>
  );
}
